import CoCartAPI from "@cocart/cocart-rest-api"

const CoCart = new CoCartAPI({
  url: process.env.REACT_APP_DOMAIN,
  // consumerKey: process.env.REACT_APP_CONSUMER_KEY,
  // consumerSecret: process.env.REACT_APP_CONSUMER_SECRET,
})

export default CoCart
